import { all } from 'redux-saga/effects';

import ProfileWatcher from "./model/profile/sagas";

export default function* IndexSaga() {
  yield all([
    ProfileWatcher()
  ]);
}